import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { ExternalLink } from "lucide-react";
import { JobStatsCard } from "../../components/admin/JobStatsCard";
import { PauseResumeButton } from "../../components/admin/PauseResumeButton";
import { UpcomingScheduleCard } from "../../components/admin/UpcomingScheduleCard";
import { useAdminJobs } from "../../hooks/admin/use-admin-jobs";

export function AdminJobs() {
  const { data: jobs, isLoading } = useAdminJobs();

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700} color="text.primary">
            Job Queue
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Monitor and control job processing
          </Typography>
        </Box>
        <PauseResumeButton />
      </Box>

      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid size={{ xs: 6, md: 3 }}>
          <JobStatsCard
            title="Pending"
            value={jobs?.pending ?? 0}
            color="info"
            loading={isLoading}
          />
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <JobStatsCard
            title="Active"
            value={jobs?.active ?? 0}
            color="warning"
            loading={isLoading}
          />
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <JobStatsCard
            title="Completed"
            value={jobs?.completed ?? 0}
            color="success"
            loading={isLoading}
          />
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <JobStatsCard
            title="Failed"
            value={jobs?.failed ?? 0}
            color="error"
            loading={isLoading}
          />
        </Grid>
      </Grid>

      <UpcomingScheduleCard />

      <Card variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
          Bull Board Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          For detailed job monitoring, queue inspection, and retry management,
          use the Bull Board dashboard.
        </Typography>
        <Button
          variant="contained"
          href="/api/admin/queues"
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<ExternalLink size={16} />}
        >
          Open Bull Board
        </Button>
      </Card>
    </Box>
  );
}
